import { useEffect, useMemo, useState } from "react";
import { AgathaSchemaParamsEnum } from "@/search/NewSearchPageMVP/types/IParametersSchema";
import { useSearchPageContext } from "@/search/NewSearchPageMVP/provider/SearchPageProvider";

export const useStandardsQuery = () => {
  const [queryHasStandardsParam, setQueryHasStandardsParam] = useState(false);

  const {
    getters: { searchParams },
    handlers: { getSearchParamValues },
  } = useSearchPageContext();
  const searchParamsObj = useMemo(
    () => (searchParams ? Object.fromEntries(searchParams.entries()) : {}),
    [searchParams],
  );

  const standardsInQuery = useMemo(
    () =>
      getSearchParamValues(AgathaSchemaParamsEnum.related_to_standards) || [],
    [JSON.stringify(searchParamsObj)],
  );

  const fetchParamsForQuery = useMemo(() => {
    if (standardsInQuery.length > 0) {
      return { content_ids: standardsInQuery.join(","), ...searchParamsObj };
    }
    if (queryHasStandardsParam) {
      return searchParamsObj;
    }
    return undefined;
  }, [standardsInQuery, queryHasStandardsParam, searchParamsObj]);

  useEffect(() => {
    // Checks necessity to toggle the queryHasStandardsParam
    setQueryHasStandardsParam(standardsInQuery.length > 0);
  }, [standardsInQuery.length]);

  return {
    fetchParamsForQuery,
    searchParamsObj,
    standardsInQuery,
  };
};
